import axios from 'axios';
import store from "@/store";
import router from '@/router';
import Vue from "vue"; // Assuming Vue.$toast is still in use for toast messages

// It's generally better to manage these outside, but for demonstration,
// we'll define them here, assuming they are set via Vue CLI environment variables.

// Microservice Base URLs configuration
// These should ideally come from environment variables, e.g., in .env.development and .env.production
const microserviceBaseUrls = {
  // Example for an 'auth' microservice
  auth: process.env.VUE_APP_AUTH_SERVICE_URL, //|| 'http://localhost:8001/',
  // Example for a 'payment' microservice
  payment: process.env.VUE_APP_PAYER_SERVICE_URL, // || 'https://localhost:9000/',
  // Add more microservices as needed
  user: process.env.VUE_APP_USER_SERVICE_URL, // || 'http://localhost:8001/',
  // Default/Legacy service if you still have one
  default: process.env.VUE_APP_BASE_URL // || 'https://localhost:9000/',
};

// Common interceptor logic for requests
const setupRequestInterceptor = (instance) => {
  instance.interceptors.request.use(request => {
    let user = store.state?.user?.user;
    if (user && user?.accessToken) {
      request.headers['Authorization'] = `Bearer ${user.accessToken}`;
    }
    return request;
  }, error => {
    return Promise.reject(error);
  });
};

// Common interceptor logic for responses
const setupResponseInterceptor = (instance) => {
  instance.interceptors.response.use(response => {
    let user = store?.state?.user?.user;
    // Check if user is relevant (e.g., password change required)
    if (user && user.user && user.user.isRelevant === false) {
      // router.push({ path: '/change-password' }); // Uncomment if this logic is still needed
    }
    return response;
  }, error => {
    var errormessage = error.response && error.response.data && error.response.data.errors && error.response.data.errors.Error
      ? error.response.data.errors.Error
      : error.message;

    if (error.response && error.response.status === 422) {
      // Handle validation errors (e.g., from Laravel backend)
      errormessage = '';
      if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach(value => {
          errormessage += value.toString() + ' ';
        });
      } else if (typeof error.response.data.errors === 'object') {
          // If errors is an object (common for validation errors), iterate its values
          for (const key in error.response.data.errors) {
              if (Array.isArray(error.response.data.errors[key])) {
                  error.response.data.errors[key].forEach(msg => {
                      errormessage += msg + ' ';
                  });
              }
          }
      }
      Vue.$toast.error(errormessage || "Validation error occurred.", { timeout: 5000 });

    } else if (error.response && error.response.status === 401) {
      // Handle unauthorized access (token expired, invalid, etc.)
      Vue.$toast.error("Authorization timeout, please login to continue", {
        timeout: 5000
      });
      // Redirect to login after a short delay
      setTimeout(function () {
        router.push({ path: '/login' });
        // location.reload(); // Consider if a full reload is strictly necessary
      }, 3000);

    } else if (error.message === 'Network Error') {
      // Handle cases where the service is unreachable
      Vue.$toast.error("Service is currently not available, please try again later", {
        timeout: 5000
      });
      setTimeout(function () {
        router.push({ path: '/login' });
        // location.reload(); // Consider if a full reload is strictly necessary
      }, 3000);
    } else {
        // General error handling for other status codes
        //Vue.$toast.error(errormessage || "An unexpected error occurred.", { timeout: 5000 });
        console.log(errormessage)
    }
    return Promise.reject(error);
  });
};

// Function to create an Axios instance for a specific microservice
const createMicroserviceApi = (serviceName) => {
  const baseURL = microserviceBaseUrls[serviceName] || microserviceBaseUrls.default;
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json', // Default content type
    },
  });

  setupRequestInterceptor(instance);
  setupResponseInterceptor(instance);

  return instance;
};

// Export individual API instances for each microservice
export const authApi = createMicroserviceApi('auth');
export const paymentApi = createMicroserviceApi('payment');
export const userApi = createMicroserviceApi('user');
// Export the default API if you still need it for legacy routes or a primary backend
export const defaultApi = createMicroserviceApi('default');

// You can still export the original 'api' if some parts of your app
// are not yet migrated to microservices or if 'default' maps to it.
// However, it's recommended to use the named exports above.
export default defaultApi; // Or remove if not needed


// --- Token Refresh Logic (if still needed, integrate with the new APIs) ---
// The original token refresh logic needs careful consideration in a microservices setup.
// If each microservice requires its own token, or if a global token is refreshed,
// the logic should be applied to all relevant axios instances.
// For simplicity, it's often handled at a higher level (e.g., Vuex action that
// updates tokens across all API instances or re-creates them).
